import type { Analytics } from '@shared/config';

import type { Destination } from '../destination';
import { createGa4Destination } from './ga4';
import { createGtmDestination } from './gtm';
import { createMatomoDestination } from './matomo';
import { createMetaPixelDestination } from './meta-pixel';
import { createPlausibleDestination } from './plausible';
import { createSegmentDestination } from './segment';
import { createTiktokPixelDestination } from './tiktok-pixel';

/**
 * The destinations a tenant has configured in `pwa.json`'s `analytics`.
 * There is no default: a tenant with none configured sends nothing.
 */
export function createDestinations(
	analytics: Analytics | undefined,
): Array<Destination> {
	const destinations: Array<Destination> = [];
	if (analytics?.gtag?.trackerID) {
		destinations.push(createGa4Destination(analytics.gtag.trackerID));
	}
	if (analytics?.gtm?.trackerID) {
		destinations.push(createGtmDestination(analytics.gtm.trackerID));
	}
	const matomo = analytics?.matomo;
	if (matomo?.urlBase && typeof matomo.siteId === 'number') {
		destinations.push(
			createMatomoDestination({
				...matomo,
				urlBase: matomo.urlBase,
				siteId: matomo.siteId,
			}),
		);
	}
	if (analytics?.plausible?.domain) {
		destinations.push(createPlausibleDestination(analytics.plausible.domain));
	}
	if (analytics?.metaPixel?.trackerID) {
		destinations.push(createMetaPixelDestination(analytics.metaPixel.trackerID));
	}
	if (analytics?.tiktokPixel?.trackerID) {
		destinations.push(
			createTiktokPixelDestination(analytics.tiktokPixel.trackerID),
		);
	}
	if (analytics?.segment?.writeKey) {
		destinations.push(createSegmentDestination(analytics.segment.writeKey));
	}
	return destinations;
}
